import styled from 'styled-components';

import { atMinWidth } from '../../../atoms/breakpoints';
import { color } from '../../../atoms/colors';
import { containers } from '../../../atoms/containers';
import { spacing } from '../../../atoms/spacing';

export const Section = styled.section`
  position: relative;
  width: 100%;
  background-color: ${color.midnight[25]};
  padding: ${spacing[48]} ${spacing[0]};

  ${atMinWidth.lg`
    padding: ${spacing[72]} ${spacing[0]};
  `}

  ${atMinWidth.xl`
    padding: ${spacing[64]} ${spacing[0]} ${spacing[96]};
  `}

  &.post-listing-section-press {
    background-color: ${color.common.white};
  }
`;

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${spacing[8]};
`;

export const Body = styled.div`
  position: relative;
  width: 100%;
  max-width: ${containers.md};
  display: flex;
  flex-direction: column;
  gap: ${spacing[30]};
  margin: ${spacing[0]} auto;
  padding: ${spacing[0]} ${spacing[16]};
  z-index: 10;

  ${atMinWidth.lg`
    padding: ${spacing[0]} ${spacing[32]};
  `}

  ${atMinWidth.xl`
    max-width: ${containers.xl};
  `}
`;

export const Grid = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${spacing[30]};

  ${atMinWidth.lg`
    display: grid;
    grid-template-columns: repeat(2, 338px);
    `}

  ${atMinWidth.xl`
    grid-template-columns: repeat(3, 1fr);
  `}
`;
